import { useNavigate } from "react-router";
// @mui
import { Chip, Stack, Typography } from "@mui/material";
// components
import { CreditsIcon, PortfolioIcon, ProjectIcon } from "src/theme/overrides/CustomIcons";
// hooks
import useResponsive from "src/hooks/useResponsive";
// 
import { PATH_DASHBOARD } from "src/routes/paths";

const TopNavbar: React.FC = () => {
  const navigate = useNavigate();
  const smUp = useResponsive('up', 'sm');

  const chipSize = smUp ? 'large' : 'medium';

  return (
    <Stack gap={1} direction={'row'} flexWrap={'wrap'}>
      <Chip
        avatar={<ProjectIcon />}
        label={<Typography variant="body2">Explore projects</Typography>}
        onClick={() => navigate(PATH_DASHBOARD.credits.browseProjects)}
        size={chipSize}
        id="nav-item-projects"
      />
      <Chip
        avatar={<PortfolioIcon />}
        label={<Typography variant="body2">Explore portfolios</Typography>}
        onClick={() => navigate(PATH_DASHBOARD.credits.portfolios)}
        size={chipSize}
        id="nav-item-portfolios"
      />
      <Chip
        avatar={<CreditsIcon />}
        label={<Typography variant="body2">Purchase credits</Typography>}
        onClick={() => navigate(PATH_DASHBOARD.credits.purchaseCredits)}
        size={chipSize}
        id="nav-item-purchase"
      />
    </Stack>
  );
};

export default TopNavbar;
